// City table columns configuration
import React from 'react';
import { Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

/**
 * Defines the column configuration for the city data table
 * @returns {Array} Array of column configuration objects for Ant Design Table
 */
const CityTableColumns = () => {
  // Custom search filter handler for text fields
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button 
            onClick={() => {
              clearFilters();
              confirm();
            }} 
            size="small" 
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
  });

  return [
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      sorter: (a, b) => a.city.localeCompare(b.city),
      ...getColumnSearchProps('city'),
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      sorter: (a, b) => a.state.localeCompare(b.state),
      ...getColumnSearchProps('state'),
    },
    {
      title: 'Customers',
      dataIndex: 'customer_count',
      key: 'customer_count',
      sorter: (a, b) => a.customer_count - b.customer_count,
      render: val => val.toLocaleString(),
    },
    {
      title: 'Sales',
      dataIndex: 'total_sales',
      key: 'total_sales',
      sorter: (a, b) => parseFloat(a.total_sales) - parseFloat(b.total_sales),
      render: val => `$${parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 0})}`,
    },
    {
      title: 'Orders',
      dataIndex: 'order_count',
      key: 'order_count',
      sorter: (a, b) => parseInt(a.order_count) - parseInt(b.order_count),
      render: val => parseInt(val).toLocaleString(),
    },
    {
      title: 'Orders/Customer',
      dataIndex: 'orders_per_customer',
      key: 'orders_per_customer',
      sorter: (a, b) => parseFloat(a.orders_per_customer) - parseFloat(b.orders_per_customer),
      render: val => parseFloat(val).toFixed(1),
    },
    {
      title: 'Repeat Rate',
      dataIndex: 'repeat_purchase_rate',
      key: 'repeat_purchase_rate',
      sorter: (a, b) => parseFloat(a.repeat_purchase_rate) - parseFloat(b.repeat_purchase_rate),
      render: val => `${parseFloat(val).toFixed(1)}%`,
    },
  ];
};

export default CityTableColumns;
